<template>
    <div>
        <template v-if="!loading">
            <b-row>
                <b-col>
                    <b-card>
                        <template #header>
                            <div class="d-flex justify-content-between">
                                <h6>Welcome {{ memberName }} ({{ memberNumber }})</h6>
                                <b-button :href="$routes.route('bookings.logout')" size="sm" type="button" variant="primary">Logout</b-button>
                            </div>
                        </template>
                        <b-card-body>
                            <FullCalendar :options="calendarConfig" @eventClick="eventClick($event)"
                                ref="gameCalendar" />
                        </b-card-body>
                    </b-card>
                </b-col>
            </b-row>
        </template>
        <public-booking-modal @closing="reset" v-if="gameId" :gameId="gameId" :memberId="memberId"></public-booking-modal>
        <public-booking-cancel-modal @closing="reset" v-if="bookedId" :bookingId="bookedId" :memberId="memberId"></public-booking-cancel-modal>
    </div>
</template>

<script>
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import listPlugin from '@fullcalendar/list';
import interactionPlugin from '@fullcalendar/interaction'
import bootstrapPlugin from '@fullcalendar/bootstrap';
import moment from 'moment-timezone';

export default {
    props: {
        bookingOpen: {
            default: false,
        },
        memberId: {
            default: false,
        },
        memberName: {
            default: false,
        },
        memberNumber: {
            default: false,
        },
        eventSources: {
            default: false,
        },
        mobile: {
            default: false,
        },
    },
    components: {
        FullCalendar // make the <FullCalendar> tag available
    },
    data() {
        return {
            calendarPlugins: [dayGridPlugin],
            loading: false,
            timer: false,
            calReload: false,
            calendarConfig: {
                plugins: [dayGridPlugin, listPlugin, interactionPlugin, bootstrapPlugin],
                themeSystem: 'bootstrap',
                initialView: this.mobile ? 'listMonth' : 'dayGridMonth',
                headerToolbar: {
                    start: '',
                    center: 'title',
                    end: 'today prev,next'
                },
                handleWindowResize: true,
                eventSources: this.eventSources.eventSources,
                eventClick: this.eventClick,
                firstDay: 1,
                timeZone: 'local',
                locale: 'en-gb',
                height: this.mobile ? 'auto' : null,
                showNonCurrentDates: false,
                eventTimeFormat: { // like '14:30:00'
                    hour: '2-digit',
                    minute: '2-digit',
                    meridiem: false,
                    hour12: false
                },
            },
            gameId: false,
            bookedId: false,
        }
    },
    methods: {
        eventClick(info) {
            info.jsEvent.preventDefault();
            if (info.event.url) {
                this.stopTimer();
                console.log(info.event.extendedProps);
    
                if (info.event.extendedProps.booked && info.event.extendedProps.cancelable) {
                    console.info('Cancel booking');
                    this.bookedId = info.event.extendedProps.booking_id;
                } else {
                    this.gameId = info.event.id;
                }
            }

            
        },
        timerReset() {
            clearTimeout(this.timer);
            this.timer = setTimeout(() => {
                window.location.href = this.$routes.route('bookings.index');
            }, (60000 * 3));
        },
        stopTimer() {
            clearTimeout(this.timer);
        },
        bindButtons() {
            setTimeout(() => {
                var buttons = document.getElementsByClassName('fc-button');
                for (var button of buttons) {
                    button.addEventListener('click', () => {
                        this.timerReset();
                    })
                }
            }, 500);
        },
        createCalReload() {
            this.calReload = setInterval(() => {
                let calApi = this.$refs.gameCalendar.getApi();
                calApi.refetchEvents();
            }, 5000);
        },
        reset() {
            this.gameId = false;
            this.bookedId = false;
            this.timerReset();
        },
        init() {
            if (!this.bookingOpen) {
                window.location.href = this.$routes.route('bookings.index');
            }

            this.timerReset();
            this.bindButtons();
            this.createCalReload();

            this.loading = false;

        },
    },
    mounted() {
        this.loading = true;
        this.init();
    },
}
</script>